module.exports = __WEBPACK_EXTERNAL_MODULE_65__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"ko-bindinghandler","commonjs2":"ko-bindinghandler","amd":"ko-bindinghandler"}
// module id = 65
// module chunks = 0